import {findMostSimilarString} from '@/utils';
import {AddressItemType, AddressSearchItem} from '../@types';
import {AddressKey} from '../enums';

export const getAddressMainKey = (
  item: AddressSearchItem,
  keyword?: string
) => {
  const altKey = item[AddressKey.roadAddressName]?.length
    ? AddressKey.roadAddressName
    : AddressKey.addressName;

  if (!keyword) {
    return altKey;
  }

  const keys = Object.values(AddressKey);

  const anyItem = item as any;
  const mainKey = keys.find((key) => anyItem[key].includes(keyword));

  if (!mainKey) {
    const array = keys.map((key) => anyItem[key]) as string[];

    const similarAddress = findMostSimilarString(keyword, array);

    if (similarAddress?.length) {
      const similarKey = keys.find((key) => anyItem[key] === similarAddress);

      if (similarKey) {
        return similarKey;
      }
    }
  }

  return mainKey || altKey;
};

export const getAddressItemKeyword = (
  item: AddressItemType,
  keyword?: string
) => {
  if (!item) {
    return '';
  } else if ('line' in item) {
    return item.name?.trim();
  } else {
    const mainKey = getAddressMainKey(item, keyword);
    return (item as any)[mainKey]?.trim();
  }
};

export const getAddressSubKey = (item: AddressSearchItem, keyword?: string) => {
  const mainKey = getAddressMainKey(item, keyword);
  let subkey: AddressKey = AddressKey.roadAddressName;

  switch (mainKey) {
    case AddressKey.placeName:
      if (!item.roadAddressName?.length) {
        subkey = AddressKey.addressName;
      }
      break;
    case AddressKey.roadAddressName:
      subkey = AddressKey.addressName;
      break;
    case AddressKey.addressName:
      subkey = AddressKey.roadAddressName;
      break;
  }

  return item[subkey]?.length ? subkey : undefined;
};
